module.exports = __webpack_public_path__ + "img/menu.27cac8d6.svg";